import request from '@/utils/request'
function findAllByStoreId (storeId) {
  return request({
    url: `/pos/product?storeId=${storeId}`,
    method: 'get'
  })
}

export default {
  findAllByStoreId
}
